<template>
  <div class="home-wrapper">
    <home-page></home-page>
  </div>
</template>

<script>
import HomePage from './home/home';
export default {
  data() {
    return {};
  },
  components: {
    HomePage,
  },
};
</script>

<style scoped>
.home-wrapper {
  width: 100%;
}
</style>
